function cordovaRenderer(config, record) {
  var args = record.args.slice(0);
  for (var i=0,len=args.length; i < len; i++) {
    if (typeof args[i] === 'object') {
      args[i] = JSON.stringify(args[i], undefined, 2);
    }
  }
  args.unshift('['+record.name+']');
  console.log.apply(console, args);
}

module.exports = {
  name: 'cordova',
  build: function(config) {
    return (function(config) {
      return function(log) {
        cordovaRenderer(config, log);
      }
    })(config);
  }
}
